/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useAuth } from '../../modules/auth'
import Masonry from 'react-masonry-css'
import {Link} from 'react-router-dom'

var username = ''
var usertype = ''
var isFacilitator = false
const breakpointColumnsObj = {
  default: 2,
  1100: 2,
  700: 1,
  500: 1
};
const coursesBackgroundUrl = toAbsoluteUrl('/media/patterns/courses-background.png');
const gamesBackgroundUrl = toAbsoluteUrl('/media/patterns/games-background.png');
const profileBackgroundUrl = toAbsoluteUrl('/media/patterns/profile-background.png');
const uploadBackgroundUrl = toAbsoluteUrl('/media/patterns/upload-background.png');
const studentsBackgroundUrl = toAbsoluteUrl('/media/patterns/students-background.png');

const DashboardPage: FC = () => (

  <>
    <div className='row gy-0'>
      <h1 className='dashboard-hello'>
        Hello, {username}! 
        <label className="dashboard-user-type-label">
          {usertype}
        </label>
      </h1>
    </div>
    {/* <div className='row gy-0'>
      
    </div> */}

    <div className="row">
      {/* Courses Item */}
      {/* <CoursesItem /> */}
      {/* Games Item */}
      {/* <GamesItem /> */}
    </div>

    <div className="row">
      {/* Profile Item */}
      {/* <ProfileItem /> */}
      {/* Facilitator Item or Student Item depending on the type of user */}
      {/* {isFacilitator ? <StudentItem /> : <FacilitatorItem />} */}
    </div>

    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column">

      <CoursesItem />
      <GamesItem />
      <ProfileItem />
      {isFacilitator ? <StudentItem /> : <FacilitatorItem />}

    </Masonry>

  </>
)

const CoursesItem = () => {

  return (
    <div className="col-sm">
      <div className="card dashboard-card"
        style={{
          backgroundImage: "url(" + coursesBackgroundUrl + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="card-body dashboard-card-body">
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <h5 className="card-title dashboard-card-title">Courses</h5>
          <Link to={'/courses'} className="btn card-button dashboard-card-button">explore</Link>
        </div>
      </div>
    </div>
  )
}

const GamesItem = () => {
  return (
    <div className="col-sm">
      <div className="card dashboard-card"
        style={{
          backgroundImage: "url(" + gamesBackgroundUrl + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="card-body dashboard-card-body">
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br><br></br>
          <h5 className="card-title dashboard-card-title">Games</h5>
          <Link to={'/games'} className="btn card-button dashboard-card-button">explore</Link>
        </div>
      </div>
    </div>
  )
}

const ProfileItem = () => {
  return (
    <div className="col-sm">
      <div className="card dashboard-card"
        style={{
          backgroundImage: "url(" + profileBackgroundUrl + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="card-body dashboard-card-body">
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br><br></br><br></br>
          <h5 className="card-title dashboard-card-title">Profile</h5>
          <Link to={'/crafted/account/settings'} className="btn card-button dashboard-card-button">explore</Link>
        </div>
      </div>
    </div>
  )
}

const FacilitatorItem = () => {
  return (
    <div className="col-sm">
      <div className="card dashboard-card"
        style={{
          backgroundImage: "url(" + uploadBackgroundUrl + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="card-body dashboard-card-body">
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br>
          <h5 className="card-title dashboard-card-title">Upload</h5>
          <Link to={'/uploads'} className="btn card-button dashboard-card-button">explore</Link>
        </div>
      </div>
    </div>
  )
}

const StudentItem = () => {
  return (
    <div className="col-sm">
      <div className="card dashboard-card"
        style={{
          backgroundImage: "url(" + studentsBackgroundUrl + ")",
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="card-body dashboard-card-body">
          <br></br><br></br><br></br><br></br><br></br>
          <br></br><br></br>
          <h5 className="card-title dashboard-card-title">Students</h5>
          <a href="#" className="btn card-button dashboard-card-button">explore</a>
        </div>
      </div>
    </div>
  )
}

const DashboardWrapper: FC = () => {
  const { currentUser } = useAuth()
  if (currentUser != null) {
    username = currentUser.first_name
    if (currentUser.occupation !== undefined) {
      usertype = currentUser.occupation
      if (usertype === "facilitator") {
        isFacilitator = true
      }
      else {
        isFacilitator = false
      }
    }
  }

  return (
    <>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
